import { AllScheduleApiResponse, ScheduleApiResponse } from "toptaal-shared"
import { getApiClient } from "../client"
import type {
  StudentUser,
  StudentProfileParams,
  StudentPasswordParams,
  UpcomingLessonsResponse,
} from "../types/user"

export async function getMe() {
  const apiClient = getApiClient()

  return await apiClient.get<StudentUser>("me").json()
}

export const editStudentUserProfile = async ({
  student,
}: StudentProfileParams) => {
  const apiClient = getApiClient()

  return await apiClient
    .post("settings/update_account", {
      json: { student },
    })
    .json()
}

export const editStudentUserPassword = async ({
  currentPassword,
  newPassword,
}: StudentPasswordParams) => {
  const apiClient = getApiClient()

  return await apiClient
    .post("settings/update_password", {
      json: { currentPassword, newPassword },
    })
    .json()
}

export async function getSchedule({
  startDate,
  endDate,
  studentId,
}: {
  startDate: string
  endDate: string
  studentId: StudentUser["userId"]
}) {
  const apiClient = getApiClient()

  return await apiClient
    .post<ScheduleApiResponse>("schedule", {
      json: {
        startDate,
        endDate,
        studentId,
      },
    })
    .json()
}

export async function getAllSchedule() {
  const apiClient = getApiClient()

  return await apiClient.get<AllScheduleApiResponse>("all_schedule").json()
}

export async function getUpcomingLessons() {
  const apiClient = getApiClient()

  return await apiClient.get<UpcomingLessonsResponse>("upcoming_lessons").json()
}
